import {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import {} from '../../utils'
import Initials from '../../../../components/Initials'
import ProfitTrendModal from '../modals/ProfitTrendModal'
import {ProfitabilityContext} from '../../context'

const CustomersTableRow = ({row}: any) => {
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)

  const {
    // Profit Trend Modal Data
    customerTypeProfitTrendChartData,
    customerTypeProfitTrendKpiData,
    customerTypeProfitTrendWeeklyBreakdownData,
    isCustomerTypeProfitTrendDataLoading,
    onCustomerTypeProfitTrendIdChange,
  } = useContext(ProfitabilityContext)
  return (
    <>
      <tr>
        <td>
          <Link
            to={`/customers/details/${row['id']}`}
            target='_blank'
            state={{
              id: row['id'],
            }}
            className='d-flex align-items-center flex-grow-1 text-start cursor-pointer'
          >
            <div className='symbol symbol-circle symbol-35px me-3 text-uppercase'>
              <Initials text={row?.customerName?.charAt(0)} />
            </div>
            <div className='d-flex flex-column'>
              <div className='align-items-center text-dark fw-semibold'>{row?.customerName}</div>
              <div className='align-items-center text-muted'>{row?.email}</div>
            </div>
          </Link>
        </td>
        <td>
          <span>{row.customerGroup}</span>
        </td>
        <td>
          <span>{row.salesRep}</span>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&customer_id=${row.customerId}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>
          <span>{row.totalCost}</span>
        </td>
        <td>
          <span>{row.revenue}</span>
        </td>
        <td>
          <span>{row.contributedRevenuePercentage}</span>
        </td>
        <td>
          <span>{row.totalProfit}</span>
        </td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td className='text-end'>
          <span>{row.contributedProfitPercentage}</span>
        </td>
      </tr>

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.customerId}
          entityName={row.customerName}
          onProfitTrendIdChange={onCustomerTypeProfitTrendIdChange}
          isProfitTrendDataLoading={isCustomerTypeProfitTrendDataLoading}
          profitTrendChartData={customerTypeProfitTrendChartData}
          kpiData={customerTypeProfitTrendKpiData}
          weeklyBreakdownData={customerTypeProfitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default CustomersTableRow
